import { Link } from 'react-router';
import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import { LogoutOutlined } from '@mui/icons-material';

export default function PaymentSuccess() {
    return (
        <Stack
            direction="column"
            height={'100vh'}
            justifyContent={'center'}
            alignItems="center"
            spacing={6}
        >
            <Alert severity="success">
                <AlertTitle>Payment Successful</AlertTitle>
                {`Thank You! Your payment has been received`}
            </Alert>
            <Button
                variant="contained"
                color="info"
                component={Link}
                to="/"
                endIcon={<LogoutOutlined />}
            >
                Return to Home
            </Button>
        </Stack>
    );
}
